export default "/_next/static/images/melinda-chelliah-0ec3f594e967056fa0a84d44ceb943ea.png";